let Quiz = (function($) {

    /**
     * Get the quiz started...
     */
    function init() {
        $('.alert').alert();

        // When a user clicks the next button...
        $('[data-next]').on('click', function(e) {
            e.preventDefault();

            let $question = $(e.currentTarget).parents('[data-question]'),
                $selected = $question.find('input:checked'),
                $alert    = $question.find('.alert'),
                action    = $selected.attr('data-next-action'),
                value     = $selected.attr('data-next-value');

            if($selected.length) {
                switch(action) {
                    case 'solution' :
                        window.location.href = value;
                        break;

                    case 'question' :
                        let $next    = $('[data-question=' + value + ']'),
                            previous = $question.attr('data-question');

                        $next.find('[data-previous]').attr('data-previous', previous);
                        $question.removeClass('active');
                        $next.addClass('active');
                        $alert.addClass('d-none').removeClass('show');

                        break;
                }
            } else {
                console.log('what');
                $alert.removeClass('d-none').addClass('show');
            }

        });

        // When a user clicks on the previous button...
        $('[data-previous]').on('click', function(e){
            e.preventDefault();

            let $this     = $(e.currentTarget),
                $question = $this.parents('[data-question]'),
                value     = $this.attr('data-previous'),
                $prev     = $('[data-question=' + value + ']');

            $question.removeClass('active');
            $prev.addClass('active');
        });
    }

    return { init: init }

})(jQuery);

jQuery(document).ready(function() {
    Quiz.init();
});
